// Wilto – klein gedrag voor de eigen secties: aankondigingsbalk (hoogte en wisselen), categorieslider, productcarrousel, voortgangslijn, winkelwagen, kortingscode kopiëren.
(() => {
  const root = document.documentElement;

  function trackAnnouncementHeight() {
    const bar = document.querySelector('#header-group .w-announce')?.closest('.shopify-section');
    if (!bar) {
      root.style.setProperty('--w-announce-h', '0px');
      return;
    }
    const set = () => root.style.setProperty('--w-announce-h', `${bar.offsetHeight}px`);
    set();
    new ResizeObserver(set).observe(bar);
  }

  function initRotator(rotator) {
    if (rotator.dataset.wReady) return;
    rotator.dataset.wReady = 'true';
    const items = [...rotator.querySelectorAll('[data-w-rotator-item]')];
    if (items.length < 2) return;
    const interval = Number(rotator.dataset.interval) || 4000;
    let index = 0;
    setInterval(() => {
      if (document.hidden) return;
      index = (index + 1) % items.length;
      items.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-active', active);
        if (active) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
        const link = item.querySelector('a');
        if (link) link.tabIndex = active ? 0 : -1;
      });
    }, interval);
  }

  function initCoverflow(root) {
    if (root.dataset.wReady) return;
    root.dataset.wReady = 'true';
    const stage = root.querySelector('[data-w-cf-stage]');
    const cards = [...root.querySelectorAll('[data-w-cf-card]')];
    const total = cards.length;
    if (!stage || total < 3) return;
    let active = 0;
    let dragStart = null;
    let dragged = false;

    const render = () => {
      const visible = Number(getComputedStyle(stage).getPropertyValue('--visible')) || 1;
      cards.forEach((card, i) => {
        let offset = i - active;
        if (offset > total / 2) offset -= total;
        if (offset < -total / 2) offset += total;
        const distance = Math.abs(offset);
        card.style.setProperty('--o', offset);
        card.style.setProperty('--abs', distance);
        card.classList.toggle('is-active', offset === 0);
        card.classList.toggle('is-far', distance > visible);
        card.toggleAttribute('inert', distance > visible);
        card.tabIndex = offset === 0 ? 0 : -1;
      });
    };
    const move = (dir) => {
      active = (active + dir + total) % total;
      render();
    };

    root.querySelector('[data-w-cf-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-w-cf-next]')?.addEventListener('click', () => move(1));
    cards.forEach((card, i) => {
      card.addEventListener('click', (event) => {
        if (dragged) {
          event.preventDefault();
          return;
        }
        if (i !== active) {
          event.preventDefault();
          active = i;
          render();
        }
      });
    });
    stage.addEventListener('pointerdown', (event) => {
      dragStart = event.clientX;
      dragged = false;
    });
    stage.addEventListener('pointerup', (event) => {
      if (dragStart === null) return;
      const delta = event.clientX - dragStart;
      dragStart = null;
      if (Math.abs(delta) > 40) {
        dragged = true;
        move(delta < 0 ? 1 : -1);
        setTimeout(() => (dragged = false), 50);
      }
    });
    stage.addEventListener('pointercancel', () => (dragStart = null));
    stage.addEventListener('dragstart', (event) => event.preventDefault());
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
    window.addEventListener('resize', render);

    root.classList.add('is-ready');
    render();
  }

  function initProgress(scroller) {
    if (scroller.dataset.wReady) return;
    scroller.dataset.wReady = 'true';
    const bar = scroller.parentElement.querySelector('[data-w-progress] span');
    if (bar) {
      const update = () => {
        const size = scroller.scrollWidth || 1;
        bar.style.width = `${(scroller.clientWidth / size) * 100}%`;
        bar.style.insetInlineStart = `${(scroller.scrollLeft / size) * 100}%`;
      };
      scroller.addEventListener('scroll', update, { passive: true });
      const sizes = new ResizeObserver(update);
      sizes.observe(scroller);
      [...scroller.children].forEach((child) => sizes.observe(child));
      update();
    }

    // Markeer de kaart die in beeld schuift, voor de glans over de titelbalk
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => entry.target.classList.toggle('is-current', entry.isIntersecting)),
      { root: scroller, threshold: 0.75 }
    );
    [...scroller.children].forEach((child) => observer.observe(child));
  }

  function initSlider(slider) {
    if (slider.dataset.wReady) return;
    slider.dataset.wReady = 'true';
    const track = slider.querySelector('[data-w-track]');
    const arrows = slider.querySelector('[data-w-arrows]');
    if (!track || !arrows) return;
    // Pijltjes alleen tonen als er iets te schuiven valt
    const update = () => arrows.toggleAttribute('hidden', track.scrollWidth - track.clientWidth <= 2);
    const sizes = new ResizeObserver(update);
    sizes.observe(track);
    [...track.children].forEach((child) => sizes.observe(child));
    update();
  }

  // Schuifpijltjes. Eén centrale klikhandler en nooit 'disabled': zo reageren de knoppen altijd,
  // ook als een sectie later is geladen. Aan het eind gaat de rij terug naar het begin, en andersom.
  function scrollByArrow(arrow) {
    const dir = arrow.matches('[data-w-scroll-prev], [data-w-prev]') ? -1 : 1;
    const inMenus = arrow.matches('[data-w-scroll-prev], [data-w-scroll-next]');
    const track = inMenus
      ? arrow.closest('.shopify-section, section, body').querySelector('[data-w-scroller]')
      : arrow.closest('[data-w-slider]')?.querySelector('[data-w-track]');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth;
    if (max <= 2) return;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= max - 2;
    if (dir > 0 && atEnd) return track.scrollTo({ left: 0, behavior });
    if (dir < 0 && atStart) return track.scrollTo({ left: max, behavior });
    let distance = track.clientWidth;
    if (inMenus) {
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      if (card) distance = card.getBoundingClientRect().width + gap;
    }
    track.scrollBy({ left: dir * distance, behavior });
  }

  async function copyCode(button) {
    const code = button.dataset.wCopy;
    const label = button.querySelector('[data-w-copy-label]');
    const status = button.closest('[data-w-code]')?.querySelector('[data-w-copy-status]');
    try {
      await navigator.clipboard.writeText(code);
      if (label) label.textContent = button.dataset.wCopied;
      if (status) status.textContent = button.dataset.wCopied;
    } catch {
      if (status) status.textContent = button.dataset.wCopyFailed;
      if (label) label.textContent = button.dataset.wCopyFailed;
    }
    clearTimeout(button.wTimer);
    button.wTimer = setTimeout(() => {
      if (label) label.textContent = button.dataset.wCopyDefault;
    }, 2500);
  }

  // Winkelwagen: aantal wijzigen en verwijderen zonder herladen. Mislukt dat, dan volgt een gewone formulierverzending.
  async function updateCart(form, submitter) {
    const cart = form.closest('[data-w-cart]');
    if (!cart || cart.classList.contains('is-busy')) return;
    const sectionId = cart.dataset.sectionId;
    const data = new FormData(form);
    if (submitter?.name) data.set(submitter.name, submitter.value);
    const key = String(data.get('id'));
    const act = submitter?.dataset.wAct;
    // De sleutel van een regel kan veranderen zodra er een korting op valt; onthoud daarom ook de positie.
    const index = [...cart.querySelectorAll('[data-w-key]')].findIndex((el) => el.dataset.wKey === key);
    const errorBox = cart.querySelector('[data-w-cart-error]');

    cart.classList.add('is-busy');
    cart.setAttribute('aria-busy', 'true');
    if (errorBox) errorBox.hidden = true;

    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: Number(data.get('quantity')),
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || '');

      const html = result.sections?.[sectionId];
      const fresh = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-w-cart]') : null;
      if (!fresh) {
        window.location.reload();
        return;
      }
      // De schakelaar van de verzekeringsapp staat in het afrekenformulier; die mag niet verdwijnen
      const widget = cart.querySelector('.ship-insurance');
      cart.innerHTML = fresh.innerHTML;
      const anchor = cart.querySelector('.cart__ctas') || cart.querySelector('button[name="checkout"]');
      if (widget && anchor && !cart.querySelector('.ship-insurance')) anchor.before(widget);
      syncInsurance();
      // Verzendbescherming telt niet mee als artikel in het bolletje
      const goods = (result.items || []).filter((line) => !/protection|insurance|lähetysturva|fraktskydd/i.test(`${line.product_type} ${line.handle} ${line.product_title}`));
      const goodsCount = result.items ? goods.reduce((sum, line) => sum + line.quantity, 0) : result.item_count;
      document.querySelectorAll('cart-icon').forEach((icon) => icon.renderCartBubble?.(goodsCount, false));

      const status = cart.querySelector('[data-w-cart-status]');
      if (status) status.textContent = cart.dataset.updatedText || '';
      const items = [...cart.querySelectorAll('[data-w-key]')];
      const item = items.find((el) => el.dataset.wKey === key) || (act === 'remove' ? null : items[index]);
      const target =
        item?.querySelector(`[data-w-act="${act}"]:not([disabled])`) ||
        item?.querySelector('[data-w-act]:not([disabled])') ||
        cart.querySelector('[data-w-cart-title]');
      target?.focus({ preventScroll: true });
    } catch (error) {
      if (error instanceof TypeError) {
        form.submit();
        return;
      }
      if (errorBox) {
        errorBox.textContent = error.message || cart.dataset.errorText || '';
        errorBox.hidden = false;
      }
    } finally {
      cart.classList.remove('is-busy');
      cart.removeAttribute('aria-busy');
    }
  }

  // Bedrag opmaken zoals Shopify dat doet, op basis van het geldformaat van de winkel
  function formatMoney(cents, format) {
    const pattern = /\{\{\s*(\w+)\s*\}\}/;
    const group = (number, precision, thousands, decimal) => {
      const [whole, fraction] = (number / 100).toFixed(precision).split('.');
      const grouped = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      return fraction ? grouped + decimal + fraction : grouped;
    };
    const kinds = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.'],
    };
    const kind = kinds[(format.match(pattern) || [])[1]] || kinds.amount;
    return format.replace(pattern, group(cents, ...kind));
  }

  // Verzendbescherming: de app voegt het product pas toe op het moment van afrekenen.
  // Staat de schakelaar aan, dan tonen we de regel en het nieuwe totaal alvast in het overzicht.
  function insurancePrice(widget) {
    const fromApp = Number(window.captain_global?.info?.price);
    if (fromApp > 0) return Math.round(fromApp * 100);
    const text = (widget.querySelector('.tm_price')?.textContent || '').replace(/\s/g, '');
    const match = text.match(/(\d+)[.,](\d{2})/);
    return match ? Number(match[1]) * 100 + Number(match[2]) : 0;
  }

  function syncInsurance() {
    const cart = document.querySelector('[data-w-cart]');
    const row = cart?.querySelector('[data-w-ins-row]');
    const total = cart?.querySelector('[data-w-cart-total]');
    if (!row || !total || row.dataset.inCart === 'true') return;
    const widget = cart.querySelector('.ship-insurance');
    const toggle = widget?.querySelector('input[type="checkbox"]');
    const cents = toggle?.checked ? insurancePrice(widget) : 0;
    const format = cart.dataset.moneyFormat || '{{amount}}';
    const priceText = cents ? `+ ${formatMoney(cents, format)}` : '';
    const totalText = formatMoney(Number(total.dataset.cents) + cents, format);
    const price = row.querySelector('[data-w-ins-price]');
    // Alleen schrijven als er iets verandert, zodat de waarnemer hieronder niet op zichzelf reageert
    if (price && price.textContent !== priceText) price.textContent = priceText;
    if (row.hidden === Boolean(cents)) row.hidden = !cents;
    if (total.textContent.trim() !== totalText) total.textContent = totalText;
  }

  function watchInsurance() {
    const cart = document.querySelector('[data-w-cart]');
    if (!cart || cart.dataset.wInsReady) return;
    cart.dataset.wInsReady = 'true';
    let frame = 0;
    const later = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(syncInsurance);
    };
    // De app zet zijn schakelaar zelf in de pagina en onthoudt de stand; daarom meekijken
    new MutationObserver(later).observe(cart, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-checked', 'checked'],
    });
    syncInsurance();
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest?.('.ship-insurance')) return;
      // De app verwerkt de klik zelf en zet de schakelaar daarna om
      [60, 400, 1200, 2500].forEach((delay) => setTimeout(syncInsurance, delay));
    },
    true
  );

  // Formulier in stappen (herroeping): pas door naar de volgende stap als de velden kloppen
  function initWizard(wizard) {
    if (wizard.dataset.wReady) return;
    wizard.dataset.wReady = 'true';
    const steps = [...wizard.querySelectorAll('[data-w-step]')];
    const chips = [...wizard.querySelectorAll('[data-w-chip]')];
    if (steps.length < 2) return;
    wizard.classList.add('is-enhanced');

    const show = (index, focus) => {
      steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      chips.forEach((chip, i) => {
        chip.classList.toggle('is-active', i === index);
        chip.classList.toggle('is-done', i < index);
        if (i === index) chip.setAttribute('aria-current', 'step');
        else chip.removeAttribute('aria-current');
      });
      if (focus) {
        const heading = steps[index].querySelector('[data-w-step-title]');
        heading?.focus({ preventScroll: true });
        wizard.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    };
    const valid = (step) => {
      const bad = [...step.querySelectorAll('input, select, textarea')].find((field) => !field.checkValidity());
      bad?.reportValidity();
      return !bad;
    };

    // Kiest de klant "wybrane produkty", dan is het tekstvak verplicht
    const scope = () => {
      const picked = wizard.querySelector('[data-w-scope]:checked')?.dataset.wScope;
      const box = wizard.querySelector('[data-w-scope-box]');
      if (!box) return;
      const partial = picked === 'partial';
      box.hidden = !partial;
      const field = box.querySelector('textarea');
      if (field) field.required = partial;
    };
    wizard.addEventListener('change', (event) => {
      if (event.target.matches('[data-w-scope]')) scope();
    });
    scope();

    wizard.addEventListener('click', (event) => {
      const next = event.target.closest('[data-w-next-step]');
      const back = event.target.closest('[data-w-prev-step]');
      const current = steps.findIndex((step) => step.classList.contains('is-active'));
      if (next && valid(steps[current])) show(Math.min(current + 1, steps.length - 1), true);
      if (back) show(Math.max(current - 1, 0), true);
    });
    // Enter in een tekstveld van stap 1 gaat naar stap 2 in plaats van te verzenden
    wizard.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !event.target.matches('input')) return;
      const current = steps.findIndex((step) => step.classList.contains('is-active'));
      if (current >= steps.length - 1) return;
      event.preventDefault();
      if (valid(steps[current])) show(current + 1, true);
    });
    // Mislukt de eindcontrole van de browser in een verborgen stap, ga dan naar die stap
    wizard.addEventListener(
      'invalid',
      (event) => {
        const index = steps.findIndex((step) => step.contains(event.target));
        if (index > -1 && !steps[index].classList.contains('is-active')) show(index, false);
      },
      true
    );
    show(Math.max(steps.findIndex((step) => step.hasAttribute('data-w-start')), 0), false);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement && event.target.matches('[data-w-cart-form]') ? event.target : null;
    if (!form) return;
    event.preventDefault();
    updateCart(form, event.submitter);
  });

  // Doorsturen naar de winkelwagen na de koopknop: zie "Mirao – snel naar de winkelwagen" onderaan.

  function init() {
    trackAnnouncementHeight();
    document.querySelectorAll('[data-w-slider]').forEach(initSlider);
    document.querySelectorAll('[data-w-rotator]').forEach(initRotator);
    document.querySelectorAll('[data-w-coverflow]').forEach(initCoverflow);
    document.querySelectorAll('[data-w-scroller]').forEach(initProgress);
    document.querySelectorAll('[data-w-wizard]').forEach(initWizard);
    watchInsurance();
  }

  // Korte tik-animatie: de klasse blijft even staan, zodat de animatie ook bij een snelle tik zichtbaar is
  document.addEventListener('pointerdown', (event) => {
    const el = event.target.closest?.('[data-w-press], .add-to-cart-button, .sticky-add-to-cart__button');
    if (!el || el.disabled) return;
    el.classList.remove('is-pressed');
    void el.offsetWidth;
    el.classList.add('is-pressed');
    clearTimeout(el.wPressTimer);
    el.wPressTimer = setTimeout(() => el.classList.remove('is-pressed'), 600);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-w-copy]');
    if (button) copyCode(button);
    const arrow = event.target.closest('[data-w-scroll-prev], [data-w-scroll-next], [data-w-prev], [data-w-next]');
    if (arrow) scrollByArrow(arrow);
  });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Mirao – Seguimiento del pedido: eigen formulier stuurt door naar ParcelPanel; op de ParcelPanel-pagina een hulpvak eronder */
(() => {
  function initTrack(root) {
    const form = root.querySelector('[data-w-track-form]');
    if (!form || form.dataset.wReady) return;
    form.dataset.wReady = 'true';
    const msg = root.querySelector('[data-w-track-msg]');
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const order = form.order.value.trim().replace(/^#/, '');
      const email = form.email.value.trim();
      if (!order || !email) {
        if (msg) msg.hidden = false;
        return;
      }
      if (msg) msg.hidden = true;
      const target = new URL(root.dataset.endpoint || '/apps/parcelpanel', window.location.origin);
      target.searchParams.set('order', order);
      target.searchParams.set('email', email);
      root.querySelector('[data-w-track-btn]')?.classList.add('is-busy');
      window.location.href = target.toString();
    });
  }

  function initParcelPanelHelp() {
    const app = document.getElementById('pp-tracking-page-app');
    if (!app || document.querySelector('.w-pp-help')) return;
    const mail = document.querySelector('a[href^="mailto:"]');
    const help = document.createElement('div');
    help.className = 'w-pp-help w-track__contact';
    help.innerHTML = '<h2 class="w-track__contact-title">¿Algo no va bien?</h2><p>Estamos aquí para ayudarte. Escríbenos y te responderemos lo antes posible.</p>';
    if (mail) {
      const a = document.createElement('a');
      a.className = 'w-btn w-btn--sm w-track__mail';
      a.href = mail.href;
      a.textContent = mail.href.replace('mailto:', '');
      help.appendChild(a);
    }
    app.insertAdjacentElement('afterend', help);
  }

  const run = () => {
    document.querySelectorAll('[data-w-track]').forEach(initTrack);
    initParcelPanelHelp();
  };
  document.addEventListener('shopify:section:load', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Mirao – eigen verzendbescherming (Protección del envío) in de winkelwagen */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const call = async (path, body) => {
    const res = await fetch(`${root}cart/${path}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(path);
    return res.json();
  };
  let busy = false;
  // De winkelwagen komt in dezelfde aanvraag opnieuw mee (sections) en wordt ter plekke vervangen:
  // geen herlaadflits. Lukt dat niet, dan alsnog de pagina herladen.
  function render(cart, html) {
    const fresh = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-w-cart]') : null;
    if (!cart || !fresh) return false;
    cart.innerHTML = fresh.innerHTML;
    return true;
  }
  async function setProtection(on, box, auto) {
    if (busy || !box) return;
    busy = true;
    box.classList.add('is-busy');
    const cart = box.closest('[data-w-cart]') || document.querySelector('[data-w-cart]');
    const sectionId = cart?.dataset.sectionId;
    const render_ = sectionId ? { sections: sectionId, sections_url: window.location.pathname } : {};
    try {
      let result;
      if (on) result = await call('add', { items: [{ id: Number(box.dataset.variant), quantity: 1 }], ...(auto ? render_ : {}) });
      else result = await call('change', { id: box.dataset.key || String(box.dataset.variant), quantity: 0 });
      // Zet de klant hem zelf uit, dan voegen we hem niet opnieuw toe
      if (!auto) result = await call('update', { attributes: { _protection_declined: on ? '' : '1' }, ...render_ });
      busy = false;
      if (!render(cart, result?.sections?.[sectionId])) window.location.reload();
    } catch (e) {
      box.classList.remove('is-busy');
      busy = false;
    }
  }
  function check() {
    const orphan = document.querySelector('[data-w-protect-orphan]');
    if (orphan && !sessionStorage.getItem('w-protect-orphan')) {
      // Alleen de bescherming over in de winkelwagen: die halen we weg
      sessionStorage.setItem('w-protect-orphan', '1');
      call('change', { id: orphan.dataset.key, quantity: 0 }).then(() => window.location.reload()).catch(() => {});
      return;
    }
    if (!orphan) sessionStorage.removeItem('w-protect-orphan');
    const box = document.querySelector('[data-w-protect]');
    if (!box) return;
    if (box.dataset.inCart === 'true') {
      sessionStorage.removeItem('w-protect-auto');
      return;
    }
    if (box.dataset.default === 'true' && box.dataset.declined !== '1' && !sessionStorage.getItem('w-protect-auto')) {
      sessionStorage.setItem('w-protect-auto', '1');
      setProtection(true, box, true);
    }
  }
  function init() {
    const cart = document.querySelector('[data-w-cart]');
    if (!cart || cart.dataset.wProtectReady) return;
    cart.dataset.wProtectReady = 'true';
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-w-protect-toggle]');
      if (!toggle) return;
      const box = toggle.closest('[data-w-protect]');
      setProtection(box.dataset.inCart !== 'true', box, false);
    });
    // Na het wijzigen van aantallen wordt de winkelwagen opnieuw opgebouwd: dan opnieuw kijken
    new MutationObserver(check).observe(cart, { childList: true });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Mirao – snel naar de winkelwagen.
   Op de productpagina (gewone koopknop en de vaste balk onderaan) gaat de klant door zodra het product
   in de winkelwagen zit: we wachten niet op de rest van het thema of apps. De verzendbescherming wordt
   daarna in de winkelwagen toegevoegd zonder herladen. Snel toevoegen vanaf productkaarten blijft zoals het was. */
(() => {
  // "Theme" komt uit snippets/scripts.liquid (const, dus geen window.Theme)
  const theme = typeof Theme === 'undefined' ? null : Theme;
  if (!String(theme?.template?.name || '').startsWith('product')) return;
  const cartUrl = theme?.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
  const quick = '.quick-add__product-form-component, .quick-add-modal__content, dialog, product-card';
  const nativeFetch = window.fetch;
  let armed = 0;
  let leaving = false;
  let pending = 0;

  const isMainButton = (el) => {
    if (!(el instanceof Element)) return false;
    if (el.closest('.sticky-add-to-cart__button')) return true;
    const button = el.closest('.add-to-cart-button, button[name="add"]');
    return !!button && !!button.closest('.product-details') && !button.closest(quick);
  };
  const arm = (event) => {
    if (isMainButton(event.target)) armed = Date.now();
  };
  document.addEventListener('pointerdown', arm, true);
  document.addEventListener('click', arm, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') arm(event);
  }, true);

  async function go() {
    if (leaving) return;
    leaving = true;
    armed = 0;
    // Wijzigt een app op hetzelfde moment nog iets aan de winkelwagen, dan wachten we daar kort op
    const started = Date.now();
    while (pending > 0 && Date.now() - started < 2500) await new Promise((resolve) => setTimeout(resolve, 30));
    window.location.assign(cartUrl);
  }

  const cartPath = (input) => {
    try {
      return new URL(typeof input === 'string' ? input : input?.url || String(input), window.location.href).pathname;
    } catch (e) {
      return '';
    }
  };
  window.fetch = function (input, init) {
    const promise = nativeFetch.apply(this, arguments);
    const method = String(init?.method || input?.method || 'GET').toUpperCase();
    const path = method === 'POST' ? cartPath(input) : '';
    if (/\/cart\/(add|update|change)(\.js|\.json)?$/.test(path)) {
      pending += 1;
      const done = () => {
        pending = Math.max(0, pending - 1);
      };
      promise.then(done, done);
      if (/\/cart\/add(\.js|\.json)?$/.test(path) && armed && Date.now() - armed < 10000) {
        promise.then((res) => {
          if (res.ok) go();
        }).catch(() => {});
      }
    }
    return promise;
  };

  // Reserve: voegt het thema toe zonder fetch, dan na afloop alsnog door
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add') return;
    const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
    if (!form || form.closest(quick)) return;
    Promise.resolve(event.promise)
      .then((result) => {
        if (!result?.detail?.didError) go();
      })
      .catch(() => {});
  });

  // Terug met de knop "vorige": de pagina komt uit het geheugen, dan opnieuw kunnen toevoegen
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      leaving = false;
      armed = 0;
    }
  });
})();
